import { useApp } from "context";
import { Link, Typography } from "@mui/material";

export const PrivacyPolicy = () => {
  const { theme } = useApp();

  return (
    <>
      <Typography>Last modified: May 30, 2023</Typography>
      <br />

      <Typography
        sx={{ textDecoration: "underline", fontWeight: theme.font.bold }}
      >
        INTRODUCTION
      </Typography>
      <br />

      <Typography sx={{ fontWeight: theme.font.bold }}>
        <b>
          Qube Hub Inc., Qube Medical Inc., Qube Health Inc., and Qasim
          Technologies Inc.
        </b>
        , (collectively as "QUBE" or "Company" or "We") respects your privacy
        and we are committed to protecting it by complying with this policy.
      </Typography>
      <br />

      <Typography component="div">
        This policy describes:
        <ul>
          <li>
            The types of information we collect from our users ("you") or that
            you may provide when you visit the website www.Qubehub.com (our
            "Website").
          </li>
          <li>
            How we collect, use, maintain, protect and disclose your information{" "}
          </li>
          <li>The process of how you control your information </li>
        </ul>
      </Typography>
      <br />

      <Typography>
        Unless otherwise compelled by relevant law, we will only use your
        personal information in accordance with this policy. We take precautions
        to guarantee that the personal data we acquire about you is sufficient,
        pertinent, not excessive, and used for certain reasons only. Canadian
        privacy legislation defines "personal information" as any data that
        identifies an individual and can be used alone or in conjunction with
        other data to identify, reach out to, or find that individual. Business
        contact information, such as your name, title, or business contact
        information, is not considered to be personal information. Information
        we obtain, use, or disclose about you is covered by this policy. Links
        to third-party websites, plug-ins, services, social networks, or
        applications may be found on the Website. By selecting those links or
        enabling those connections, you might give the third-party permission to
        gather or share information about you. Please be aware that any other
        parties you visit through links or third-party plugins have their own
        privacy rules, and we disclaim any responsibility or accountability for
        those policies. We urge you to read the privacy policies of every
        website you visit because we have no control over these third-party
        websites. Please read this policy carefully. If disagree with our
        policies and practices, you are choosing not to use our Website. By
        accessing or using this Website, you indicate that you understand,
        accept, and consent to the practices described in this policy.
      </Typography>
      <br />

      <Typography
        sx={{ textDecoration: "underline", fontWeight: theme.font.bold }}
      >
        INFORMATION WE COLLECT ABOUT YOU
      </Typography>
      <br />

      <Typography component="div">
        We collect and use several types of information from and about you,
        including:
        <ul>
          <li>Name</li>
          <li>Mailing address</li>
          <li>Phone number</li>
          <li>Email address</li>
          <li>Health card </li>
          <li>Insurance provider - policy number </li>
          <li>Preferred pharmacy</li>
          <li>Sex</li>
          <li>Age</li>
          <li>Payment/Billing Information</li>
          <li>Billing address</li>
        </ul>
      </Typography>
      <br />

      <Typography
        sx={{ textDecoration: "underline", fontWeight: theme.font.bold }}
      >
        HOW WE COLLECT INFORMATION
      </Typography>
      <br />

      <Typography>
        Some content or applications on the Website, including advertisements,
        are served by third-parties. These third parties may use cookies to
        collect information about you when you use our Website. The information
        they collect may be associated with your personal information or about
        your online activities over time and across different websites and other
        online services. We do not control these third parties' tracking
        technologies or how they are used. If you have any questions about an
        advertisement or other targeted content, you should contact the
        responsible provider directly. You can opt-out of several third-party ad
        servers' and networks' cookies simultaneously by using an opt-out tool
        created by the{" "}
        <Link href="https://youradchoices.ca/choices/">
          Digital Advertising Alliance of Canada.
        </Link>
      </Typography>
      <br />

      <Typography
        sx={{ textDecoration: "underline", fontWeight: theme.font.bold }}
      >
        HOW WE USE YOUR INFORMATION
      </Typography>
      <br />

      <Typography component="div">
        We use information:
        <ul>
          <li>To introduce you to our platform and its contents.</li>
          <li>To book appointments with health care providers </li>
          <li>To comply with the Terms of Service Agreement</li>
          <li>To send you notifications regarding your appointment</li>
          <li>
            To fulfill our commitments and uphold our rights under any contracts
            we may have with you, including for invoicing and collection
            purposes or to adhere to legal requirements.
          </li>
          <li>
            To let you know when we make any changes to our website, the items
            or services we offer there, or both.
          </li>
          <li>
            To enhance our website, products, services, marketing, and
            interactions with customers.
          </li>
          <li>
            For any other reason with your approval, as we may specify when you
            provide the information.
          </li>
        </ul>
      </Typography>
      <br />

      <Typography>
        We may use the data we have gathered from you to display adverts to the
        target markets of our advertisers. Although we never share your personal
        information for these reasons without your permission, the advertiser
        may believe that you fit its target demographic if you click on or
        otherwise interact with an advertisement.
      </Typography>
      <br />

      <Typography
        sx={{ textDecoration: "underline", fontWeight: theme.font.bold }}
      >
        DISCLOSURE OF YOUR INFORMATION
      </Typography>
      <br />

      <Typography component="div">
        We may disclose personal information:
        <ul>
          <li>To our Health providers and affiliates.</li>
          <li>
            In accordance with applicable law, to a buyer or other successor in
            the event of a merger, divestiture, restructuring, reorganization,
            dissolution, or other sale or transfer of some or all of Qube's
            assets, whether as a going concern or as part of bankruptcy,
            liquidation, or similar proceeding, in which personal information
            held by Qube about our customers and users is among the assets
            transferred.
          </li>
          <li>
            For any other purpose disclosed by us when you provide the
            information.
          </li>
          <li>With your consent.</li>
          <li>
            To enforce or apply our terms of use [LINK TO WEBSITE'S TERMS OF
            USE] and other agreements, including for billing and collection
            purposes.
          </li>
          <li>
            If we believe disclosure is necessary or appropriate to protect the
            rights, property, or safety of Qube, our customers, or others.
          </li>
        </ul>
      </Typography>
      <br />

      <Typography
        sx={{ textDecoration: "underline", fontWeight: theme.font.bold }}
      >
        TRANSFERRING YOUR PERSONAL INFORMATION
      </Typography>
      <br />

      <Typography>
        We may transfer your information to the contractors, service providers,
        and other third parties we use to support our business (like analytics
        and search engine providers who help us with Website improvement and
        optimization) and who are contractually obligated to keep personal
        information confidential, use it only for the purposes for which we
        disclose it to them, and to process the personal information that we
        collect or that you provide as described in this policy. Your personal
        information may be processed, stored, and transferred in a foreign
        nation with different privacy regulations that might or might not be as
        stringent as Canadian law. In some situations, the laws of the foreign
        country may allow the governments, courts, law enforcement, or
        regulatory authorities of that nation to get access to your personal
        information. Every time we hire a service provider, we demand that they
        follow this policy and all relevant Canadian privacy laws with regard to
        privacy and security.
      </Typography>
      <br />

      <Typography
        sx={{ textDecoration: "underline", fontWeight: theme.font.bold }}
      >
        DATA SECURITY
      </Typography>
      <br />

      <Typography>
        We place a high priority on protecting the security of your personal
        information. To protect your personal information against unintentional
        loss and from unauthorized access, use, alteration, and disclosure, we
        employ physical, electronic, and administrative safeguards. You are also
        responsible for the privacy and security of your data. You are in charge
        of safeguarding any password we may have provided you (or that you may
        have chosen) for access to particular areas of our website. Please
        refrain from disclosing your password to anyone. There is no method of
        transmission over the internet, or method of electronic storage that is
        100% secure and reliable, and we cannot guarantee its absolute security.
        Personal information is sent at the sender's own risk. Any privacy
        settings or security features on the Website may be circumvented without
        our knowledge and without liability. We will only keep your personal
        information for as long as is necessary to complete the reasons for
        which it was acquired, including to meet any legal, accounting, or
        reporting requirements, unless otherwise permitted or required by
        relevant law or regulation.
      </Typography>
      <br />

      <Typography
        sx={{ textDecoration: "underline", fontWeight: theme.font.bold }}
      >
        ACCESSING AND CORRECTING YOUR PERSONAL INFORMATION
      </Typography>
      <br />

      <Typography>
        It is important that the personal data we collect is accurate and up to
        date. If your personal information changes, please let us know. You have
        the legal right to ask us to access and update any personal data we may
        have on you. In order to make the requested modifications or to provide
        you with the personal information we hold about you, we may need
        particular information from you to assist us verify your identity and
        access rights. According to applicable legislation, we may be able or
        required to deny you access to any or all of the personal data we have
        on you. Alternatively, we may have anonymized, deleted, or destroyed
        your personal data in accordance with our record-keeping duties and
        procedures. Subject to any legal or regulatory restrictions, we will let
        you know why we are unable to give you access to your personal
        information and why. If you are concerned about our response or would
        like to correct the information provided, you may contact us.
      </Typography>
      <br />

      <Typography
        sx={{ textDecoration: "underline", fontWeight: theme.font.bold }}
      >
        WITHDRAWING YOUR CONSENT
      </Typography>
      <br />

      <Typography>
        You may have the legal right to withdraw your consent to the collection
        and use of your data. To withdraw your consent, if applicable, contact
        us. Please note that if you withdraw your consent, we may not be able to
        provide you with a particular product or service.
      </Typography>
      <br />

      <Typography
        sx={{ textDecoration: "underline", fontWeight: theme.font.bold }}
      >
        CHANGES TO OUR PRIVACY POLICY
      </Typography>
      <br />

      <Typography>
        If our policy is amended, we make it our priority to notify our users.
        If we make material changes to how we treat our users' personal
        information, we will notify you by email. It is your responsibility to
        ensure that you are up to date with our privacy policy. The date it was
        last revised will be indicated at the top of the page.
      </Typography>
      <br />

      <Typography
        sx={{ textDecoration: "underline", fontWeight: theme.font.bold }}
      >
        CONTACT US
      </Typography>
      <br />

      <Typography>
        If you have questions, comments, and requests regarding this privacy
        policy and our privacy practices. Please contact us at:{" "}
        <Link href="mailto:admin@qubehub.com">admin@qubehub.com</Link>
      </Typography>
      <br />
    </>
  );
};
